import type { SidebarItem } from '@/types/nav';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/atoms/Sidebar';

import { cn } from '@/utils/tailwind';

interface DefaultItemProps {
  item: SidebarItem;
  isActive?: boolean;
}

export function DefaultItem({ item, isActive }: DefaultItemProps) {
  const Icon = isActive ? item.iconFill : item.iconOutline;

  return (
    <SidebarMenuItem className="" key={item.title}>
      <SidebarMenuButton
        variant="main"
        asChild
        isActive={isActive}
        className="w-full cursor-pointer"
        tooltip={{ children: <SidebarTooltipSubItems item={item} /> }}
      >
        <a
          href={item.url}
          className={cn(
            'group/a flex h-full w-full cursor-pointer items-center gap-[14px] px-[13px] py-[12px]',
          )}
        >
          {Icon && <Icon className={cn('h-6 w-6 ')} />}
          <span className={cn('Body3S15', { 'text-white': isActive, 'text-gr-700': !isActive })}>
            {item.title}
          </span>
        </a>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

function SidebarTooltipSubItems({ item }: { item: SidebarItem }) {
  return (
    <div
      className="flex flex-col gap-1 
    rounded-xl border bg-white p-[8px] py-[12px] text-[14px] font-medium leading-[24px] shadow-lg "
    >
      <a
        href={item.url}
        className="block whitespace-nowrap rounded-xl py-[8px] pl-[8px] pr-[32px] text-left text-sm text-gr-800 transition-colors hover:bg-gr-200"
      >
        {item.title}
      </a>
    </div>
  );
}
